export default "/_next/static/fonts/bb50377578e825b8f75c409b629aeae4.woff2";